import { SceneObject, TextSceneObject } from '@cgs/wge';
import { IconValueDescription } from './corsica-icon-values.types';

export const enum PanelStates {
  Static = 'panel_static',
  Anim = 'panel_anim',
}

export function createIconValueDescription(
  value: number,
  position: number,
  textSceneId: string,
  panelAnimState: PanelStates = PanelStates.Static
): IconValueDescription {
  return {
    value,
    position,
    textSceneId,
    panelAnimState,
  };
}

export function drawIconValue(iconNode: SceneObject, valueDescription: IconValueDescription): void {
  const panelStates = iconNode.findById<SceneObject>('panelStates');

  if (panelStates && panelStates.stateMachine) {
    if (valueDescription.panelAnimState === PanelStates.Anim) {
      panelStates.stateMachine.switchToState(PanelStates.Static);
    }

    panelStates.stateMachine.switchToState(valueDescription.panelAnimState);
  }

  const textStates = iconNode.findById<SceneObject>('textStates');
  if (textStates && textStates.stateMachine) {
    textStates.stateMachine.switchToState('text_with_mult');
  }

  const texts = iconNode.findAllByType(TextSceneObject) || [];

  for (const text of texts) {
    text.text = valueDescription.value.toString();
    text.format = `x{0}`;
  }
}
